import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/hosting/dedicated-servers")({
  component: () => <Outlet />,
});
